namespace TotalContest {
    import Service = TotalCore.Common.Service;

    @Service('services.totalcontest')
    export class RepositoryService {
        private resource;

        constructor($resource, private $httpParamSerializerJQLike, private prefix, private ajaxEndpoint, private contestId, private submissionId) {
            this.resource = $resource(ajaxEndpoint, {}, {
                list: {method: 'GET', cache: true, params: {contest: contestId, submission: submissionId}},
                status: {method: 'GET', cache: false},
                remove: {method: 'POST', cache: true}
            });

            return this;
        }

        getPage(page: number, filters = {}) {
            return this.resource
                .list(angular.extend({}, {action: `${this.prefix}_log_list`, page: page}, filters))
                .$promise
                .then((response) => {
                    response['entries'] = response['entries'].map((entry) => {
                        return new Entry(entry);
                    });

                    return response;
                });
        }

        getExport(format: string, filters = {}, columns = null) {
            return this.resource
                .list(angular.extend({}, {action: `${this.prefix}_log_export`, contest: this.contestId, submission: this.submissionId, format: format, 'columns[]': columns}, filters))
                .$promise
                .then((response) => {
                    return response.data;
                });
        }

        getExportStatus(uid: string) {
            return this.resource
                .status({action: `${this.prefix}_log_export_status`, uid: uid})
                .$promise
                .then((response) => {
                    return response.data;
                });
        }

        getDownload(format, filters = {}) {
            let iframe = document.createElement('iframe');
            let query = this.$httpParamSerializerJQLike(angular.extend({}, {action: `${this.prefix}_log_download`, contest: this.contestId, submission: this.submissionId, format: format}, filters));
            iframe.src = `${this.ajaxEndpoint}?${query}`;
            document.body.appendChild(iframe);
        }

        remove(id:number) {
            return this.resource.remove({
                action : `${this.prefix}_log_remove`,
                id: id
            }).$promise;
        }
    }
}
